(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/coupon.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  var getMarketplaceAccount = svs.maltipset.helpers.getMarketplaceAccount;
  var isMarketplaceToggled = svs.maltipset.helpers.isMarketplaceToggled;
  svs.maltipset.views.Coupon = Backbone.Marionette.View.extend({
    regions: {
      couponHeader: '.coupon-header',
      matchList: '.maltipset-match-list',
      board: '.maltipset-board',
      drawSelector: '#drawChooser',
      header: '.maltipset-matchlist-head',
      betslip: '#betslip-wrapper'
    },
    modelEvents: {
      'xpert:startLoad': 'xpertStarLoad',
      'xpert:doneLoad': 'xpertDoneLoad',
      'xpert:error': 'xpertError',
      'wager:payError': 'paymentError',
      'wager:paySuccess': 'paymentSuccess',
      'change:system createBaseRow stopBaseRowEdit': 'columnChange',
      'change:hasMarkedMatches': 'updateContextMenu',
      'change:actionBar change:system': 'showActionBar',
      'change:totalSelectedMatches': 'updateActionBar'
    },
    ui: {
      matches_cols: '#js-matches-cols',
      board_container: '.maltipset-board-container',
      matclist_board_container: '.matchlist-board-container'
    },
    log: new svs.core.log.Logger('svs.maltipset.views.Coupon'),
    AUTHENTICATED_SAM_NOT_ASM: 3107,
    NOT_AUTHENTICATED: 100005,
    SALES_STOPPED: 8124,
    REG_BET_REJECTED: 8105,
    template: function template(data) {
      return svs.maltipset.templates.coupon(data);
    },
    initialize: function initialize() {
      if (svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile()) {
        this.addRegion('betslipOverview', '#maltipset-slider-folder');
      }

      this.bindUIElements();
    },
    onAttach: function onAttach() {
      this.getRegion('matchList').show(new svs.maltipset.views.MatchList({
        collection: this.model.get('draw').get('matchList')
      }));
      this.createBoardView();
      this.getRegion('couponHeader').show(new svs.maltipset.views.CouponHeader({
        model: this.model
      }));

      if (svs.core.detect.feature('ft-maltipset-direct-play') || svs.core.detect.feature('ft-maltipset-context-menu')) {
        svs.maltipset.controllers.maltipsetController.initContextMenu({
          isStartPage: false,
          system: this.model.get('system'),
          showMenuInHeader: false,
          enableClearAll: _.filter(svs.maltipset.models.storageCoupon.get('selectedMatches'), function (arr) {
            return arr.length;
          }).length > 0
        });
      } else {
        if (!svs.core.detect.formfactor.mobile()) {
          svs.maltipset.controllers.maltipsetController.initContextMenu({
            isStartPage: false,
            system: this.model.get('system'),
            enableClearAll: _.filter(svs.maltipset.models.storageCoupon.get('selectedMatches'), function (arr) {
              return arr.length;
            }).length > 0
          });
        }
      }

      this.showActionBar();

      if (svs.core.detect.feature('ft-betslip') && svs.core.detect.feature('ft-betslip-maltipset') && !svs.core.detect.formfactor.mobile()) {
        svs.maltipset.views.betslipOverview = undefined;
        svs.maltipset.views.betslipOverview = new svs.maltipset.views.BetslipOverview({
          coupon: this.model
        });
        this.getRegion('betslipOverview').show(svs.maltipset.views.betslipOverview);
      }
    },
    onRender: function onRender() {
      this.setBoardColumns();

      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.addDrawSelector();
      }
    },

    setBoardColumns: function setBoardColumns() {
      this.ui.matches_cols.removeClass();
      this.ui.board_container.attr('class', 'maltipset-board-container');

      if (this.model.get('xpertBaseRowMode')) {
        this.ui.matches_cols.addClass('col-xs-8');
        this.ui.board_container.addClass('xpert-base-row col-xs-4');
      } else {
        if (!this.model.isMOrRSystem()) {
          this.ui.matches_cols.addClass('col-xs-6 col-md-4');
          this.ui.board_container.addClass('col-xs-6 col-md-8');
        } else {
          this.ui.matches_cols.addClass('col-xs-8');
          this.ui.board_container.addClass('system-active col-xs-4');
        }
      }

      if (!this.model.get('xpertBaseRowMode') && !this.model.collection.hasManyDraws() && svs.core.detect.formfactor.mobile() && !svs.core.detect.feature('ft-betslip-maltipset')) {
        this.ui.matclist_board_container.addClass('sticky-padding-top');
      } else {
        this.ui.matclist_board_container.toggleClass('sticky-padding-top', false);
      }
    },
    createBoardView: function createBoardView() {
      if (this.boardView) {
        this.boardView.close();
      }

      this.boardView = new svs.maltipset.views.Board({
        collection: this.model.get('board'),
        coupon: this.model
      });
      this.getRegion('board').show(this.boardView);
    },
    columnChange: function columnChange() {
      if (svs.core.detect.feature('ft-betslip-maltipset') && svs.maltipset.views.betslip) {
        svs.maltipset.views.betslip.setWidth();
      }

      this.setBoardColumns();
      this.createBoardView();
    },
    showActionBar: function showActionBar() {
      switch (this.model.get('actionBar')) {
        case svs.maltipset.constants.ACTIONBARS.SYSTEM:
          this.systemShow();
          break;

        case svs.maltipset.constants.ACTIONBARS.XPERT:
          this.xpertShow();
          break;

        case svs.maltipset.constants.ACTIONBARS.BASEROW:
          this.showBaseRowActionBar();
          break;

        case svs.maltipset.constants.ACTIONBARS.NO_BAR:
          svs.sport.actionbar.hide();
          break;

        default:
      }

      svs.sport.actionbar.reposition();

      if (svs.core.detect.formfactor.mobile() && !svs.core.detect.feature('ft-betslip-maltipset')) {
        this.$el.find('.matchlist-board-container').toggleClass('padding-bottom-3', this.model.get('actionBar') !== svs.maltipset.constants.ACTIONBARS.NO_BAR);
      }
    },
    systemShow: function systemShow() {
      if (this.model.isMOrRSystem()) {
        var coupon = this.model;
        var system = this.model.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM ? 'M-System' : 'R-System';
        var options = {
          leftButton: {
            type: svs.core.detect.formfactor.mobile() ? 'button' : 'text',
            text: "<span class=\"padding-sm-right\">".concat(system, "</span>"),
            visible: true,
            disabled: !svs.core.detect.formfactor.mobile(),
            callback: function callback() {
              svs.maltipset.controllers.maltipsetController.showSystemspel();
            }
          },
          centerButton: {
            type: 'link',
            text: '',
            icon: 'icon-default icon-300 icon-rensa-app',
            visible: true,
            callback: function callback() {
              svs.maltipset.controllers.maltipsetController.convertSystem(svs.maltipset.constants.SYSTEM.NO_SYSTEM);
            }
          }
        };

        _.defer(function () {
          svs.sport.actionbar.show(options, coupon);
        });
      } else {
        this.model.removeActionbar();
      }
    },
    updateContextMenu: function updateContextMenu() {
      svs.maltipset.controllers.maltipsetController.initContextMenu({
        isStartPage: false,
        showMenuInHeader: !svs.core.detect.feature('ft-maltipset-direct-play') && !svs.core.detect.feature('ft-maltipset-context-menu'),
        system: this.model.get('system'),
        enableClearAll: this.model.get('hasMarkedMatches')
      });
    },
    updateActionBar: function updateActionBar() {
      if (this.model.get('actionBar') === svs.maltipset.constants.ACTIONBARS.BASEROW) {
        this.showBaseRowActionBar();
      }
    },
    showBaseRowActionBar: function showBaseRowActionBar() {
      var actionBar;
      var self = this;
      svs.sport.actionbar.show({
        leftButton: {
          type: 'text',
          text: this.model.get('matchesLeftToMaxSelect') > 0 ? 'Välj de matcher du vill ha som säkra' : 'Detta system tillåter inte fler makeringar som grundrad',
          visible: true
        },
        rightButton: {
          type: 'link',
          text: '',
          icon: 'icon-default icon-300 icon-rensa-app',
          visible: true,
          callback: function callback() {
            self.model.stopBaseRowEdit();
          }
        },
        bottomView: {
          text: 'Gör minst en markering och lämna minst en match omarkerad'
        },
        bottomButton: {
          type: 'button',
          text: 'Generera rader',
          visible: true,
          disabled: this.model.get('totalSelectedMatches') === 0,
          callback: function callback() {
            this.model.newXpert(true);
          }
        }
      }, this);
      setTimeout(function () {
        actionBar = document.getElementsByClassName('actionbar')[0];

        if (actionBar) {
          actionBar.classList.add('actionbar-clear-bottom-border');
        }
      });
    },
    showTipsInfoActionBar: function showTipsInfoActionBar() {
      var coupon = this.model;
      var options = {
        leftButton: {
          type: svs.core.detect.formfactor.mobile() ? 'button' : 'text',
          text: 'Tipsinfo',
          visible: true,
          disabled: !svs.core.detect.formfactor.mobile(),
          callback: function callback() {
            svs.maltipset.controllers.maltipsetController.showTipsInfo();
          }
        },
        centerButton: {
          type: 'text',
          text: "<span class=\"padding-sm-right\">".concat(svs.maltipset.models.tipsInfo.getNumberOfTipsinfo(), " valda </span>"),
          visible: true
        },
        rightButton: {
          type: 'link',
          text: 'Göm tipsinfo',
          icon: null,
          visible: true,
          callback: function callback() {
            svs.maltipset.models.tipsInfo.emptyTipsInfo();
            coupon.removeActionbar();
          }
        },
        closeButton: {
          callCallbackOnHide: false,
          callback: function callback() {
            coupon.removeActionbar();
          }
        }
      };

      _.defer(function () {
        svs.sport.actionbar.show(options, coupon);
        svs.sport.actionbar.reposition();
      });
    },
    xpertShow: function xpertShow() {
      this.createBoardView();
      var coupon = this.model;
      var currentSystem = null;

      if (this.model.isMOrRSystem()) {
        currentSystem = this.model.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM ? 'M' : 'R';
      }

      var options = {
        leftButton: {
          type: svs.core.detect.formfactor.mobile() ? 'button' : 'text',
          text: !currentSystem ? "Xperten ".concat(coupon.get('totalCompleteRows'), " rader") : "Xperten ".concat(currentSystem, " ").concat(coupon.get('numberOfSelectedMatches')),
          disabled: !svs.core.detect.formfactor.mobile(),
          visible: true,
          callback: function callback() {
            svs.maltipset.controllers.maltipsetController.showXperten();
            return true;
          }
        },
        centerButton: {
          type: 'button',
          icon: 'icon-default icon-300 icon-refresh',
          visible: true,
          callback: function callback() {
            this.newXpert(!_.isUndefined(this.get('baseRow')));
            return true;
          }
        },
        rightButton: {
          type: 'link',
          text: '',
          icon: 'icon-default icon-300 icon-rensa-app',
          visible: true,
          callback: function callback() {
            this.empty(true);
          }
        }
      };
      svs.sport.actionbar.show(options, coupon);
    },
    xpertError: function xpertError(response) {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'help-2',
        title: 'Det går tyvärr inte att spela på Xperten just nu',
        actions: [{
          title: 'OK'
        }]
      }));
      this.log.debug("Error getting xpert: ".concat(response.status, ": ").concat(response.statusText));
    },
    xpertStarLoad: function xpertStarLoad() {
      svs.components.loader.show();
    },
    xpertDoneLoad: function xpertDoneLoad() {
      svs.components.loader.hide();
    },
    paymentSuccess: function paymentSuccess(wager) {
      var _this = this;

      var marketplaceAccount = isMarketplaceToggled() && getMarketplaceAccount();
      var marketPlaceUrl;

      if (marketplaceAccount) {
        marketPlaceUrl = svs.utils.urlMapping.get('marketplace') + svs.components.marketplace.helpers.getTeamUrl(marketplaceAccount.groupId, marketplaceAccount.name, 'spel', marketplaceAccount.containerId, marketplaceAccount.activatedDrawId);
      }

      svs.components.sport.getPaymentDoneMessage({
        amount: wager.get('totalCostFormatted'),
        productName: 'Måltipset',
        marketplaceUrl: marketPlaceUrl,
        isRetailer: svs.maltipset.data.isRetailerAdmin
      }, function (messageObject) {
        _this.log.debug('getPaymentDoneMessage callback ', messageObject);

        svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.paymentDoneDialogConfig));
      });
      this.model.changeSystem(svs.maltipset.constants.SYSTEM.NO_SYSTEM);

      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        var url = '';
        var afterGameTab = 'relaterat',
            hasRelatedTab = svs.maltipset.data.config.startPageConfig.tabs.some(function (tab) {
          return tab.anchor === afterGameTab && tab.active === true;
        });

        if (hasRelatedTab) {
          url = "?flik=".concat(afterGameTab);
        }

        svs.maltipset.router.navigate(url, {
          trigger: true
        });
      } else {
        svs.maltipset.router.navigate('', {
          trigger: true
        });
      }
    },
    paymentError: function paymentError(response) {
      var errCodestr = String(response.error.code);
      var errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
      var errMessage;
      var errTitle;

      switch (errCode) {
        case this.AUTHENTICATED_SAM_NOT_ASM:
          svs.core.userSession.logout();
          errTitle = 'Du måste logga in först.';
          break;

        case this.NOT_AUTHENTICATED:
          errTitle = 'Du måste logga in först.';
          break;

        case this.SALES_STOPPED:
          errTitle = 'Omgången är stängd för spel, vänligen försök senare';
          break;

        case this.REG_BET_REJECTED:
          if (response.error.message.indexOf('DEFINED') > 0) {
            errTitle = 'Omgången har inte öppnat för spel, vänligen försök senare';
          } else {
            errTitle = 'Omgången har stängt';
          }

          break;

        default:
          svs.accountservices.player_exclusions.hasExclusionOnVertical('sport', function (data) {
            if (data && data.hasExclusions) {
              errTitle = 'Du har en aktiv spelpaus';
              errMessage = data.exclusionInfo;
            } else {
              errTitle = 'Något gick tyvärr fel';
              errMessage = 'Försök igen om en stund';
            }
          });
      }

      svs.sport.sport_common.showErrorDialog(errTitle, errMessage);
      this.log.debug("Error in payment: ".concat(response.error.code, ": ").concat(response.error.message));
    },
    addDrawSelector: function addDrawSelector() {
      var drawselectorOptions = {
        callback: function callback(drawNum) {
          Backbone.history.navigate("/".concat(drawNum), {
            trigger: true,
            replace: true
          });
        },
        draws: svs.maltipset.collections.draws.getAllDraws(),
        currentDraw: svs.maltipset.collections.coupons.getCurrentCoupon().get('draw').get('drawNumber'),
        branding: 'maltipset',
        swiperUpdateFunction: this.updateSwiper
      };
      this.getRegion('drawSelector').show(new svs.sport.drawselector.views.Drawselector(drawselectorOptions));
    }
  });
})(Backbone, _, svs);
 })(window);